import { pageRanges } from "./documentUtils";
import { RECIPIENT_FIELDS } from "./constants";
import { recipientSources } from "./sources";

const normalize = (value) =>
  (value || "").trim().replace(/\s+/g, " ").toLocaleLowerCase("pl");
export const recipientKey = (item) =>
  JSON.stringify(RECIPIENT_FIELDS.map((field) => normalize(item[field])));

/** Grupuje identyczne dane odbiorcy z zachowaniem ról i źródeł. */
export function groupRecipients(candidates, roles) {
  const groups = new Map();
  candidates.forEach((candidate, candidateIndex) => {
    if (!RECIPIENT_FIELDS.some((field) => normalize(candidate[field]))) return;
    const key = recipientKey(candidate);
    const group = groups.get(key) || { ...candidate, key, sources: [] };
    const role =
      roles[(candidate.label || "").toLowerCase().replace(/[ -]/g, "")];
    const source = {
      candidateIndex,
      references: recipientSources(candidate),
      role: role || candidate.label || "Dane z dokumentu",
      location: [
        candidate.sourceName,
        candidate.pages?.length
          ? `${new Set(candidate.pages).size === 1 ? "strona" : "strony"} ${pageRanges(candidate.pages)}`
          : "",
      ]
        .filter(Boolean)
        .join(" · "),
    };
    if (
      !group.sources.some(
        (item) =>
          item.role === source.role && item.location === source.location,
      )
    )
      group.sources.push(source);
    groups.set(key, group);
  });
  return [...groups.values()];
}
